const INFO = {
	main: {
		title: "SB Statistical Consulting",
		name: "SB Statistical Consulting",
		email: "hbump35@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/",
		linkedin: "https://linkedin.com/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "SB Statistical Consulting",
		description:
			"Combining academic excellence, including a master’s in applied statistics, with over five years of experience across six industries, we bridge the gap between theory and practical results. From Fortune 500 companies to university classrooms and collaborative research initiatives, our work is driven by one goal:",
	},

	about: {
		title: "I’m Tharindu N. I live in Sri Lanka, where I design the future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},
	projects: [
		{
			title: "Statistical Testing",
			description:
				"We provide comprehensive statistical testing services including hypothesis testing, power analysis, and study design validation. Our expertise helps researchers and organizations ensure their findings are statistically sound and actionable.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/r/r.png",
			linkText: "Learn More",
			link: "#",
		},

		{
			title: "Data Analysis and Predictive Modeling",
			description:
				"Transform your data into actionable insights with our advanced analytics and predictive modeling services. We build custom models to forecast trends, optimize operations, and drive data-informed decision making for your business.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "Learn More",
			link: "#",
		},
	],
};

export default INFO;
